<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" :rules="rules" ref="form" label-width="150px">
        <div class="row-title">油罐基础信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygCode" label="油罐名称">
              <el-input v-model="formData.ygCode" placeholder="请输入油罐名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygRegion" label="所属库区">
              <el-select v-model="formData.ygRegion" clearable filterable placeholder="请选择所属库区">
                <el-option v-for="([key, value], index) of regionMap" :value="key" :label="value"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item prop="ygLevel" label="当前液位(米)">
              <el-input-number
                :precision="2"
                @change="levelChange"
                v-model="formData.ygLevel"
                :min="-99999999"
                :max="maxHeight"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygTemperature" label="当前温度(℃)">
              <el-input
                placeholder="请输入温度"
                v-model="formData.ygTemperature"
              >
                <template slot="append">℃</template>
</el-input>
</el-form-item>
</el-col>
</el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygType" label="储油规格">
              <el-select v-model="formData.ygType" clearable placeholder="请选择储油规格">
                <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygAllWeight" label="总容量(吨)">
              <el-input v-model="formData.ygAllWeight" :min="-99999999" :max="99999999"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygWeight" label="当前存油量(吨)">
              <el-input disabled v-model="formData.ygWeight"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item prop="ygDensity" label="当前密度(t/m³)">
              <el-input
                placeholder="请输入当前密度(t/m³)"
                v-model="formData.ygDensity"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygDiameter" label="直径(米)">
              <el-input-number
                :precision="2"
                v-model="formData.ygDiameter"
                :min="-99999999"
                :max="99999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item prop="ygHeight" label="油罐高度(米)">
              <el-input-number
                :precision="2"
                v-model="formData.ygHeight"
                :min="-99999999"
                :max="99999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygTime" label="数据变更时间">
              <el-date-picker
                v-model="formData.ygTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="请选择数据变更时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button type="primary" class="global-button" @click="submit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { region } from '@/utils/dict'
function validYgDensity(rule, value, callback) {
  if (!/^\d+(\.\d{1,3})?$/.test(value)) {
    return callback(new Error('密度格式为数字可保留3为小数'))
  } else {
    callback()
  }
}
export default {
  name: 'OiltankManageAdd',
  data() {
    return {
      specList: [],
      formData: {
        ygAllWeight: ''
      },
      regionMap: region,
      rules: {
        ygCode: [{ required: true, message: '请输入油罐名称', trigger: 'blur' }],
        ygRegion: [{ required: true, message: '请选择所属区域', trigger: 'change' }],
        ygLevel: [{ required: true, message: '请输入当前液位', trigger: 'blur' }],
        ygTemperature: [{ required: true, message: '请输入当前温度', trigger: 'blur' }],
        ygDiameter: [{ required: true, message: '请输入直径(米)', trigger: 'blur' }],
        ygAllWeight: [{ required: true, message: '请输入总容量', trigger: 'blur' }],
        ygDensity: [
          { required: true, message: '请输入当前密度', trigger: 'blur' },
          { validator: validYgDensity, trigger: ['blur', 'change'] }
        ],
        ygType: [{ required: true, message: '请选择储油规格', trigger: 'change' }],
        ygHeight: [{ required: true, message: '请输入油罐高度', trigger: 'blur' }],
        // ygLeaseTerm: [{ required: true, message: '请选择租赁到期时间', trigger: 'change' }],
        ygTime: [{ required: true, message: '请选择更新时间', trigger: 'change' }]

      },
      userList: []
    }
  },
  created() {
    this.loadSpecList()
    if (this.id) {
      this.loadData()
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    maxHeight() {
      if (this.formData.ygHeight) {
        return parseFloat(this.formData.ygHeight)
      } else {
        return 100
      }
    }
  },
  methods: {
    levelChange(height) {
      if (this.formData.ygDiameter && this.formData.ygDensity) {
        this.formData.ygWeight = Math.pow((this.formData.ygDiameter / 2), 2) * Math.PI * height * this.formData.ygDensity
      }
    },
    loadData() {
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByYgId, {
        params: { ygId: this.id }
      }).then(res => {
        this.formData = res || {}
      })
    },
    loadSpecList() {
      this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
        this.specList = res.list || []
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        // let url = this.$apis.oiltabkManage.updateYgInfo
        // if (this.id) {
        const url = this.$apis.oiltabkManage.updateYgInfo
        // }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.row-title {
  font-size: 14px;
  position: relative;
  padding-left: 14px;
  margin-bottom: 20px;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    height: 14px;
    width: 3px;
    background-color: #36f;
    border-radius: 2px;
    transform: translateY(-50%);
  }
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
